// src/components/IDE/ide/editor/breakpoints.ts
import {
    gutter,
    GutterMarker,
    //  EditorView 
} from '@codemirror/view';
import { RangeSetBuilder, Extension } from '@codemirror/state';

class Dot extends GutterMarker {
    toDOM() {
        const el = document.createElement('div');
        el.style.width = '8px';
        el.style.height = '8px';
        el.style.margin = '0 auto';
        el.style.borderRadius = '50%';
        el.style.background = '#f5222d';
        return el;
    }
}
const dot = new Dot();

// Spacer dédié pour fixer la largeur de base du gutter
class Spacer extends GutterMarker {
    toDOM() {
        const el = document.createElement('div');
        el.style.width = '8px';
        el.style.height = '8px';
        return el;
    }
}
const spacer = new Spacer();

export function breakpointGutter(getLines: () => number[]): Extension {
    return gutter({
        class: 'cm-breakpoint-gutter',
        markers(view) {
            const builder = new RangeSetBuilder<GutterMarker>();
            const lines = getLines();
            for (const line1 of lines) {
                if (line1 < 1 || line1 > view.state.doc.lines) continue; // garde-fou
                const line = view.state.doc.line(line1);
                builder.add(line.from, line.from, dot);
            }
            return builder.finish();
        },
        // ⬅️ doit retourner un GutterMarker (pas un HTMLElement)
        initialSpacer: () => spacer, // (tu peux aussi mettre: () => dot)
        domEventHandlers: {
            mousedown(view, lineInfo) {
                const line1 = view.state.doc.lineAt(lineInfo.from).number; // 1-based
                const ev = new CustomEvent('cm-toggle-breakpoint', { detail: { line1 } });
                view.dom.dispatchEvent(ev);
                return true;
            },
        },
    });
}
